import { useTranslation } from 'react-i18next';
import { TabGroup, TabButton } from '../../ui/Tabs/index.js';
import type { DevelopPointView } from './develop-point-view.js';

interface DevelopPointViewSwitchProps {
  /** 選択中のビュー */
  view: DevelopPointView;
  /** ビュー変更コールバック */
  onChange: (view: DevelopPointView) => void;
}

/** ボタンの並び順（全部 → 要件定義抜き → 内訳） @graph-connects none */
const VIEWS: readonly DevelopPointView[] = ['all', 'excludeRequirement', 'breakdown'];

/**
 * 開発pt の 全部 / 要件定義抜き / 内訳 切替スイッチ。
 * 「開発pt (MTD)」カードと「週次pt集計」カードの右上に同じものを置き、ページ内の 1 つの
 * ビュー状態を共有する（どちらで切り替えても両方のカードが同じ口径になる）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 開発pt の表示口径（全部 / 要件定義抜き / 内訳）を切り替えるピル型スイッチ。開発pt (MTD) カードと週次pt集計カードで共有する
 * @graph-connects TabGroup [calls] ピル型タブの描画
 * @graph-connects TabButton [calls] 各ビューのボタン描画
 */
export function DevelopPointViewSwitch({ view, onChange }: DevelopPointViewSwitchProps) {
  const { t } = useTranslation();
  return (
    <TabGroup ariaLabel={t('kpi.developPointView.switchLabel')} shape="pill">
      {VIEWS.map((v) => (
        <TabButton
          key={v}
          active={view === v}
          label={t(`kpi.developPointView.${v}`)}
          onClick={() => {
            onChange(v);
          }}
        />
      ))}
    </TabGroup>
  );
}
